import { render, staticRenderFns } from "./observation.vue?vue&type=template&id=b9814116"
import script from "./observation.vue?vue&type=script&lang=js"
export * from "./observation.vue?vue&type=script&lang=js"
import style0 from "./observation.vue?vue&type=style&index=0&id=b9814116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports